// @flow
import React from 'react';
import { connect } from 'react-redux';
import { MdAssignment } from 'react-icons/lib/md';
import i18n from 'i18n-js';
import { reset, clearFields, change } from 'redux-form';
import { getReport } from './reportConstants';
import * as reportActions from '../../actions/reports';
import styles from './reportSidebar.css';
import * as selectors from '../../reducers';

type RouteSidebarPropTypes = {
  name: string,
  setReport: Function,
  clearFields: Function,
  change: Function,
  resetForm: Function,
  selected: string,
};

const ReportsSidebar = ({
  name = '',
  setReport,
  change,
  clearFields,
  resetForm,
  selected = 'bus_arrivals_departure_time',
}: RouteSidebarPropTypes) => {
  const REPORT_NAMES = getReport();
  return (
    <div className={styles.reportSidebar}>
      <div className={styles.reportSidebarTitle}>
        <MdAssignment size={32} />
        <h1>
          {i18n.t('common.reports')}
        </h1>
      </div>
      <div className={styles.reportList}>
        {REPORT_NAMES.map(elm => (
          <div key={elm.key} className={styles.reportElement}>
            <a
              onClick={() => {
                resetForm('createReport');
                clearFields('createReport', false, false, 'selectedElement', 'date_range');
                setReport(elm.key);
              }}
              className={
              `${styles.reportLink}
               ${selected === elm.key ? styles.selected : ''}`
              }
            >
              { elm.name }
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default connect(
  (state) => {
    const selected = selectors.getCurrentReportKey(state);
    return {
      selected,
    };
  },
  dispatch => ({
    setReport: (key: string) => dispatch(reportActions.setReport(key)),
    resetForm: (key: string) => dispatch(reset(key)),
    clearFields: (key: string) => dispatch(clearFields(key)),
    change: (key: string) => dispatch(change(key)),
  }),
)(ReportsSidebar);



// WEBPACK FOOTER //
// ./src/scripts/components/ReportSidebar/index.jsx